import {z} from 'zod';

import i18n from '@/i18n';
import type {MarkResidentAsAbsentInput} from '@/services/graphqlHooks';

export const markResidentAsAbsentFormSchema = z.object({
  id: z.string().trim().min(1, i18n.t('Resident is required')),
  content: z.string().trim().min(1, i18n.t('Content is required')),
});

export type MarkResidentAsAbsentFormValues = z.infer<
  typeof markResidentAsAbsentFormSchema
>;

export const markResidentAsAbsentFormDefaultValues = (
  input?: MarkResidentAsAbsentInput
): MarkResidentAsAbsentFormValues => ({
  id: input?.id || '',
  content: input?.content || '',
});
